import React from "react";
import useIsMobile from "../hooks/useIsMobile";
import AdminSimpleResourceMobile from "../mobile/admin/AdminSimpleResourceMobile";
import GestionTaxes from "./GestionTaxes";

export default function ResponsiveGestionTaxes(props) {
  return useIsMobile() ? <AdminSimpleResourceMobile resource="taxes" {...props} /> : <GestionTaxes {...props} />;
}
